import { appInsights } from '@/lib/ApplicationInsightsService';
import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';

export interface ILoaderProps {
  showBackdrop?: boolean;
  solidBackground?: boolean;
}

export const Loader = (props: ILoaderProps) => {
  const { showBackdrop = true, solidBackground = true } = props;
  const auth = useAuth();
  const waitTimer = useRef(0);
  if (!auth.isAuthenticated) {
    appInsights.trackEvent({ name: 'Unauthenticated use of Loader' });
  }
  useEffect(() => {
    waitTimer.current = window.setTimeout(() => {
      appInsights.trackEvent({ name: 'Long Duration on Loader spinner page' });
    }, 30000);
    return () => {
      if (waitTimer.current) {
        window.clearTimeout(waitTimer.current);
      }
    };
  });
  const spinner = <div className={`loader__spinner`} />;

  return (
    <>
      {showBackdrop && (
        <div
          className={`loader ${solidBackground ? 'loader__solid-background' : ''} grid h-screen w-screen content-center justify-items-center`}
          role="img"
          aria-label="Loading"
        >
          {spinner}
        </div>
      )}
      {!showBackdrop && spinner}
    </>
  );
};

export default Loader;
